<script setup lang="ts">
import { computed } from 'vue'
// types
import type { StrapiMedia } from '@ts-strapi/interfaces'
// helpers
import { resolveStrapiMediaUrl } from '@helpers/strapi-media'

interface HeaderLogoProps {
  logo: StrapiMedia
  logoMobile: StrapiMedia | null
  link: string
  mobile?: boolean
}

defineOptions({
  name: 'HeaderLogo',
})

const props = withDefaults(defineProps<HeaderLogoProps>(), {
  mobile: false,
})

const { strapi, wpOriginUrl } = useRuntimeConfig().public

const refActive = computed<StrapiMedia>(() => (props.mobile && props.logoMobile) ? props.logoMobile : props.logo)
const refSrc = computed<string>(() => resolveStrapiMediaUrl(refActive.value.url, strapi.publicUrl))
const refHref = computed<string>(() => props.link === '/' ? wpOriginUrl : props.link)
</script>

<template>
  <NuxtLink
    :to="refHref"
    class="header-logo"
  >
    <img
      class="header-logo__img"
      :src="refSrc"
      :alt="refActive.alternativeText || 'Brighterly'"
      :width="refActive.width"
      :height="refActive.height"
      decoding="async"
    >
  </NuxtLink>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/Headers/HeaderLogo.scss" />
